import styled from 'styled-components'

export const OptionsGrid = styled.div`
  display: grid;
  justify-content: center;
  gap: 12px;
  margin-top: 15px;
  width: 100%;

  grid-template-columns: repeat(4, 250px);

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 250px);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 250px);
  }

  @media (max-width: 540px) {
    grid-template-columns: 1fr;
  }
`

export const ProfessionalsGrid = styled.div`
  display: grid;
  gap: 5px;
  justify-items: stretch;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  margin-top: 15px;

  @media (min-width: 640px) {
    width: 600px;
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 639px) {
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
  }
`

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  padding: 0px;
  gap: 3px;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
`

export const ProfessionalPicture = styled.img`
  width: 100px;
  height: 100px;
`

export const SmallButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  margin-bottom: 10px;
  border: 0px;
  gap: 8px;

  &:hover {
    color: #FFC100;
  }
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  line-height: 18px;
  margin: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 7px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 0px;
`
